import { User } from '@src/entities/User/ui/components/User';
import { DeleteNoteButton } from '@src/features/ActionPaths/DeleteNote';
import { EditNoteButton } from '@src/features/ActionPaths/EditNote';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import React from 'react';

/**
 * Widget: Notes
 *
 * Renders a widget displaying notes for the action path, with options to edit or delete them.
 *
 * @param actionPath
 * @returns {Element}
 * @constructor
 */
export function Notes({ actionPath = {} }) {
  return (
    <ErrorHandler location="src/widgets/ActionPaths/Notes/Notes.jsx">
      <User.Capability attributes={['read:note']} method="hide" resource="ActionPaths">
        <Widget
          description={`Last updated by: ${actionPath?.lastModifiedBy} on ${dayjs(actionPath?.lastModifiedDate).format(
            'MM/DD/YYYY'
          )}`}
          key="notes-widget"
          title="Notes"
        >
          <Grid>
            <Grid.Col span={{ xs: '100%' }}>
              <pre
                style={{
                  fontFamily: 'var(--abyss-fonts-primary)',
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                }}
              >
                {actionPath?.note}
              </pre>
            </Grid.Col>
            <Grid.Col span={{ xs: '50%' }}>
              <EditNoteButton actionPath={actionPath} />
            </Grid.Col>
            <Grid.Col css={{ textAlign: 'right' }} span={{ xs: '50%' }}>
              <DeleteNoteButton actionPath={actionPath} />
            </Grid.Col>
          </Grid>
        </Widget>
      </User.Capability>
    </ErrorHandler>
  );
}
